// B18 – Swatches + comportamiento unificado en TODAS las grillas
// - Hover en swatch (desktop): muestra 1ª imagen de ese color
// - Mouseleave: regresa a la variante seleccionada
// - Click en swatch:
//      • si NO era el activo → selecciona color (cambia imagen + link)
//      • si YA era el activo (solo desktop) → abre el producto
// - Click en imagen o título: abre la variante actualmente seleccionada
// - Funciona en colecciones y en "También puede gustarte" (product-recommendations)

(function () {
  var isMobile = window.matchMedia('(max-width: 767px)').matches;

  // ---------------- Helpers ----------------
  function getCurrentSrc(el) {
    if (!el) return null;
    return (
      el.currentSrc ||
      el.src ||
      el.getAttribute('data-src') ||
      el.getAttribute('src') ||
      null
    );
  }

  function applyImage(el, url) {
    if (!el || !url) return;
    var currentSrc =
      el.currentSrc || el.src || el.getAttribute('data-src') || el.getAttribute('src');
    if (currentSrc === url) return;

    el.setAttribute('src', url);
    el.removeAttribute('srcset');

    if (el.dataset) {
      el.dataset.src = url;
      if (el.dataset.srcset) {
        el.dataset.srcset = url;
      }
    }
    if (el.getAttribute('data-src')) {
      el.setAttribute('data-src', url);
    }
    if (el.getAttribute('data-srcset')) {
      el.setAttribute('data-srcset', url);
    }
  }

  function applyPrimaryToCard(card, url) {
    var img = card.querySelector('.grid-product__image-mask img');
    if (!img || !url) return;
    applyImage(img, url);
  }

  function applySecondaryToCard(card, url) {
    var img = card.querySelector('.grid-product__secondary-image img');
    if (!img || !url) return;
    applyImage(img, url);
  }

  // ---------------- Inicialización por tarjeta ----------------
  function initCard(card) {
    if (!card || card.dataset.b18Init === 'true') return;
    card.dataset.b18Init = 'true';

    // 1) Estado base de imágenes y URL
    var mainImg = card.querySelector('.grid-product__image-mask img');
    var secondaryImg = card.querySelector('.grid-product__secondary-image img');
    var productLink = card.querySelector('.grid-product__link');

    var defaultUrl =
      card.getAttribute('data-default-url') ||
      (productLink && productLink.getAttribute('href')) ||
      '';

    var originalPrimary = getCurrentSrc(mainImg);
    var originalSecondary = getCurrentSrc(secondaryImg);

    card.dataset.originalPrimary = originalPrimary || '';
    card.dataset.originalSecondary = originalSecondary || '';

    card.dataset.selectedImage = originalPrimary || '';
    if (originalSecondary) {
      card.dataset.selectedSecondary = originalSecondary;
    }

    card.dataset.currentUrl = defaultUrl || '';
    if (productLink && defaultUrl) {
      productLink.setAttribute('href', defaultUrl);
    }

    // 2) Swatches
    var selectedVariantId =
      card.dataset.selectedVariantId ||
      card.getAttribute('data-selected-variant-id') ||
      '';

    card.dataset.selectedVariantId = selectedVariantId || '';

    var swatches = card.querySelectorAll(
      '.grid-product__colors-track .color-swatch[data-variant-image]'
    );

    swatches.forEach(function (swatch) {
      var variantImgUrl = swatch.getAttribute('data-variant-image');
      var variantSecondUrl = swatch.getAttribute('data-variant-secondary-image');
      var productUrl = swatch.getAttribute('data-product-url');
      var variantId = swatch.getAttribute('data-variant-id');

      if (!variantImgUrl) return;

      // Hover solo en desktop
      if (!isMobile) {
        swatch.addEventListener('mouseenter', function () {
          applyPrimaryToCard(card, variantImgUrl);
        });

        swatch.addEventListener('mouseleave', function () {
          var selected =
            card.dataset.selectedImage || card.dataset.originalPrimary || '';
          if (selected) {
            applyPrimaryToCard(card, selected);
          }
        });
      }

      // Click en swatch
      swatch.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        // Desktop: si ya está activo → navegar a la variante
        if (!isMobile && swatch.classList.contains('is-active')) {
          if (productUrl) {
            window.location.href = productUrl;
          }
          return;
        }

        // Seleccionar este color
        if (variantId) {
          card.dataset.selectedVariantId = variantId;
        }

        card.dataset.selectedImage = variantImgUrl;
        applyPrimaryToCard(card, variantImgUrl);

        var second =
          variantSecondUrl ||
          card.dataset.originalSecondary ||
          card.dataset.selectedSecondary ||
          '';
        if (second) {
          card.dataset.selectedSecondary = second;
          applySecondaryToCard(card, second);
        }

        if (productUrl) {
          card.dataset.currentUrl = productUrl;
          if (productLink) {
            productLink.setAttribute('href', productUrl);
          }
        }

        // Marcar activo solo dentro de ESTA tarjeta
        var siblings = card.querySelectorAll(
          '.grid-product__colors-track .color-swatch'
        );
        siblings.forEach(function (s) {
          s.classList.remove('is-active');
        });
        swatch.classList.add('is-active');
      });

      // Swatch activo inicial = variante mostrada
      if (!card.dataset.hasActiveSwatch && selectedVariantId && variantId) {
        if (variantId === selectedVariantId) {
          swatch.classList.add('is-active');
          card.dataset.hasActiveSwatch = 'true';
        }
      }
    });

    // Fallback: si no se marcó ninguno como activo, marcamos el primero
    if (card.dataset.hasActiveSwatch !== 'true') {
      var first = card.querySelector(
        '.grid-product__colors-track .color-swatch'
      );
      if (first) {
        first.classList.add('is-active');
        card.dataset.hasActiveSwatch = 'true';
      }
    }

    // 3) Click en la IMAGEN → abrir variante seleccionada
    var imageMask = card.querySelector('.grid-product__image-mask');
    if (imageMask) {
      imageMask.addEventListener('click', function (event) {
        // que no se dispare si, por alguna razón, el click viene de un swatch
        if (event.target.closest('.color-swatch')) return;

        var url = card.dataset.currentUrl || card.getAttribute('data-default-url');
        if (!url) {
          // fallback al link normal
          var link = card.querySelector('.grid-product__link');
          if (link) url = link.getAttribute('href');
        }
        if (url) {
          window.location.href = url;
        }
      });
    }

    // 4) Carrusel de swatches (flechas) por tarjeta
    var track = card.querySelector('.grid-product__colors-track');
    var prev = card.querySelector('.grid-product__colors-arrow--prev');
    var next = card.querySelector('.grid-product__colors-arrow--next');

    if (track && prev && next) {
      var step = 80;

      var updateArrows = function () {
        var maxScroll = track.scrollWidth - track.clientWidth;

        if (maxScroll <= 0) {
          prev.style.display = 'none';
          next.style.display = 'none';
          return;
        }

        prev.style.display = '';
        next.style.display = '';

        prev.disabled = track.scrollLeft <= 0;
        next.disabled = track.scrollLeft >= maxScroll - 1;
      };

      prev.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        track.scrollBy({ left: -step, behavior: 'smooth' });
        setTimeout(updateArrows, 200);
      });

      next.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        track.scrollBy({ left: step, behavior: 'smooth' });
        setTimeout(updateArrows, 200);
      });

      track.addEventListener('scroll', updateArrows);
      updateArrows();
    }
  }

  // ---------------- Inicializar dentro de un root ----------------
  function initB18Cards(root) {
    if (!root) return;
    var cards = root.querySelectorAll('.grid__item.grid-product:not([data-b18-init])');
    cards.forEach(initCard);
  }

  // ---------------- Arranque en carga inicial + observer ----------------
  document.addEventListener('DOMContentLoaded', function () {
    initB18Cards(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof HTMLElement)) return;

          if (node.matches && node.matches('.grid__item.grid-product')) {
            initB18Cards(node.parentNode || node);
          } else if (node.querySelector) {
            if (node.querySelector('.grid__item.grid-product')) {
              initB18Cards(node);
            }
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
})();





document.addEventListener('DOMContentLoaded', function () {
  var form = document.getElementById('CartPageForm');
  if (!form) return;

  var termsCheckbox = document.getElementById('CartTerms');
  if (!termsCheckbox) return;

  var termsLabel = form.querySelector('label[for="CartTerms"]');

  // 1) Evitar que el click en el checkbox o label se "propague"
  //    y algún script lo use para enviar el formulario.
  [termsCheckbox, termsLabel].forEach(function (el) {
    if (!el) return;
    el.addEventListener(
      'click',
      function (event) {
        // Permitimos que el checkbox se marque,
        // pero frenamos cualquier otro listener "global".
        event.stopPropagation();
      },
      true // fase de captura: se ejecuta ANTES que otros listeners
    );
  });

  // 2) (Opcional pero recomendable) – Bloquear el checkout si NO aceptan términos
  var checkoutBtn = form.querySelector('.cart__checkout');
  if (!checkoutBtn) return;

  form.addEventListener('submit', function (event) {
    if (
      checkoutBtn.dataset.termsRequired === 'true' &&
      !termsCheckbox.checked
    ) {
      event.preventDefault();
      alert('Por favor acepta los términos y condiciones para continuar.');
    }
  });
});
